import {SearchParamsInterface} from "../interface/SearchParamsInterface";
import configAxios from "../configuration/configAxios";
import {interceptorResponse} from "../../utils/decode/decoding";
import {errorHandlerServices, getError} from "../configuration/errorHandle";
import {useMutation, UseMutationResult} from "@tanstack/react-query";

export const findAcademics = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/information/academic_titles`,
        {
            identifier: data.identifier
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return interceptorResponse(response.data.object)
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/information/academic_titles', undefined, data?.msj)
        getError(error, error?.response?.data?.message ? error?.response?.data?.message : `Error service: /information/academic_titles`);
    })
}

export const useFindAcademics = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findAcademics(data),
    });
}
